import { render, staticRenderFns } from "./UserTaskConfig.vue?vue&type=template&id=d6653b74&scoped=true"
import script from "./UserTaskConfig.vue?vue&type=script&lang=js"
export * from "./UserTaskConfig.vue?vue&type=script&lang=js"
import style0 from "./UserTaskConfig.vue?vue&type=style&index=0&id=d6653b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6653b74",
  null
  
)

export default component.exports